var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content c-top" },
        [
          _c("breadcrumb-search", {
            attrs: { breadcrumbSearch: _vm.searchList },
          }),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "info-form",
              staticStyle: { "margin-top": "22px" },
              attrs: {
                "label-width": "110px",
                rules: _vm.rules,
                model: _vm.form,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标签名称", prop: "tagName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      placeholder: "请输入标签名称",
                      maxlength: "5",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.tagName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "tagName", $$v)
                      },
                      expression: "form.tagName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签图片", prop: "tagImg" } },
                [
                  _c("upload-picture", {
                    attrs: {
                      imageUrl: _vm.form.tagImg,
                      width: "128px",
                      height: "128px",
                    },
                    on: { getUrl: _vm.getImage },
                  }),
                  _c("div", { staticClass: "messageI" }, [
                    _vm._v(
                      " 图片尺寸：建议上传尺寸1:1，大小不得超过2M,支持jpg、jpeg、png格式 "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签排序", prop: "sort" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "442px" },
                    attrs: {
                      placeholder: "请输入排序数字",
                      oninput: "value=value.replace(/[^0-9]/g, '')",
                    },
                    model: {
                      value: _vm.form.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "sort", $$v)
                      },
                      expression: "form.sort",
                    },
                  }),
                  _c("div", { staticClass: "messageI" }, [
                    _vm._v("数字越大越靠后"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "442px" },
                      attrs: {
                        placeholder: "请选择状态",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "启用", value: "true" },
                      }),
                      _c("el-option", {
                        attrs: { label: "禁用", value: "false" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { height: "20px" } }),
          _c(
            "div",
            { staticClass: "back-btn" },
            [
              _c(
                "el-button",
                { attrs: { type: "info" }, on: { click: _vm.back } },
                [_vm._v("返回")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }